import React from "react";
import LeadsTableBody from "./LeadsTableBody";

/**
 * Wrapper for rendering Internship Leads rows.
 * Job-like layout (no domain/modes) but without the Job-only "Quote Sent" column.
 */
function InternshipLeadsTable(props) {
  return <LeadsTableBody {...props} activeTab="Internship Leads" />;
}

export default InternshipLeadsTable;

